import moment from 'moment';
import React from 'react';

import { BasicInfoBox } from './VehicleCard';
import {
  InfoBoxDateValueContainer,
  InfoBoxTitle,
  InfoDateBoxValue,
  StyledCalendarDateIcon,
  VehicleInfoBoxContainer,
} from './VehicleCard.styles';

export interface DateBox extends BasicInfoBox {
  date: Date;
}

const VehicleDateBox = ({ data }: { data: DateBox }) => {
  const date = data.date;
  const currentDate = moment(date).format('ll');

  return (
    <VehicleInfoBoxContainer $minWidth={data.minWidth}>
      {data.title && <InfoBoxTitle>{data.title}</InfoBoxTitle>}
      <InfoBoxDateValueContainer>
        <StyledCalendarDateIcon />
        <InfoDateBoxValue>{currentDate}</InfoDateBoxValue>
      </InfoBoxDateValueContainer>
    </VehicleInfoBoxContainer>
  );
};

export default VehicleDateBox;
